module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/feedback-70bd1cbeaa56cb23c82e9ead3493fc7f.svg";